import React, { useEffect } from 'react';
import {
  FiAlertCircle,
  FiAlertTriangle,
  FiCheckCircle,
  FiInfo,
  FiMinusCircle,
  FiXCircle,
} from 'react-icons/fi';

import { BoxMessage, useBoxMessage } from '../../../hooks/boxMessage';

import { BoxMessageStyled } from './styles';

interface BoxMessageProps {
  message: BoxMessage;
  style: object;
}

const icons = {
  info: <FiInfo size={24} />,
  success: <FiAlertCircle size={24} />,
  error: <FiMinusCircle size={24} />,
  warning: <FiAlertTriangle size={24} />,
};

const Box: React.FC<BoxMessageProps> = ({ message, style }) => {
  const { removeBoxMessage } = useBoxMessage();

  useEffect(() => {
    const timer = setTimeout(() => {
      removeBoxMessage(message.id);
    }, 15000);
    return () => {
      clearTimeout(timer);
    };
  }, [message.id, removeBoxMessage]);

  return (
    <BoxMessageStyled
      $type={message.type}
      $hasDescription={!!message.description}
      style={style}
    >
      {icons[message.type || 'info']}

      <div>
        <strong>{message.title}</strong>
        {message.description && <p>{message.description}</p>}
      </div>

      <button onClick={() => removeBoxMessage(message.id)} type="button">
        <FiXCircle size={24} />
      </button>
    </BoxMessageStyled>
  );
};

export default Box;
